import { createFileRoute } from "@tanstack/react-router";
import { ClaimsWorkspace } from "@/components/AdditionalWorkspaces";

export const Route = createFileRoute("/claims")({ component: ClaimsWorkspace });
